// Chats
import urls from '../constants/Urls';
import LocalStorageService from './local-storage-service';
import UrlUtils from '../utils/url-utils/UrlUtils';
import http from './HttpService';

const getChannel = ({ rtId, partnerId }) => {
  const microserviceUrl = LocalStorageService.getBaseUrl();
  const replacedUrl = UrlUtils.replaceUrlParams(urls.GET_STOREKEEPER_CHANNEL, {
    rtId,
    partnerId,
  });
  return http.get(`${microserviceUrl}${replacedUrl}`, {
    headers: { AUTH_OWNER: 'application_users' },
  });
};

export default { getChannel };
